import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { analyticsSaveForLater } from "../../../state/modules/analytics/actions";
import {
  saveProduct,
  removeSavedProduct,
  isProductSaved
} from "../../../state/modules/savedItems";
import { withTranslation } from "../../translation";
import { setError } from "../../../state/modules/error";
import SaveForLater from "./SaveForLater";
import commonConfig from "../../../config/common";

const ConnectedSaveForLater = props => {
  const { eventIconType } = commonConfig;
  const dispatch = useDispatch();

  return (
    <SaveForLater
      {...props}
      analyticsSaveForLater={args => dispatch(analyticsSaveForLater(args))}
      saveProductInState={args => dispatch(saveProduct(args))}
      removeSavedProduct={args => dispatch(removeSavedProduct(args))}
      setError={args => dispatch(setError(args))}
      isSaved={useSelector(state => isProductSaved(state, props.productId))}
      eventIconType={eventIconType}
    />
  );
};

ConnectedSaveForLater.propTypes = {
  productId: PropTypes.number.isRequired
};

export default withTranslation(ConnectedSaveForLater);
